export const GALLERY_TEST_ID = {
    DEFAULT: 'default',
    LIGHTBOX: 'lightbox',
    LIGHTBOX_CLOSE_BTN: 'light-box-close',
    LIGHTBOX_NEXT_BTN: 'light-box-next',
    LIGHTBOX_PREV_BTN: 'light-box-prev',
    LIGHTBOX_IMAGE: 'light-box-img',
};
